/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';

import { Row, Col, Pagination } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { map } from 'lodash';

const PaginationInterval = props => {
  const { globalIndex, currentPage, setCurrentPage, elementePage, elementPagination } = props;
  const [totalPage, setTotalPage] = React.useState(0);
  const [pagesToShow, setPagesToShow] = React.useState([1, 2]);
  const pagesTo = prop => {
    const a = elementPagination;
    const arr = [];
    let i = 0;
    const b = Math.floor(a / 2);

    if (prop > 0) {
      if (prop < a) {
        do {
          i += 1;
          arr.push(i);
        } while (i < prop);
      } else {
        if (currentPage <= a - b) {
          do {
            i += 1;
            arr.push(i);
          } while (i < a);
          return arr;
        }
        if (currentPage >= prop - b) {
          do {
            i += 1;
            arr.push(i + prop - a);
          } while (i < a);
          return arr;
        }

        do {
          arr.push(i + currentPage - b);
          i += 1;
        } while (i < a);
        return arr;
      }
    }
    return arr;
  };
  const filterops = () => {
    const pages = globalIndex / elementePage;
    setTotalPage(Math.ceil(pages));
    const arr = pagesTo(Math.ceil(pages));
    setPagesToShow([...arr]);
  };

  React.useEffect(() => {
    const arr = pagesTo(totalPage);
    setPagesToShow([...arr]);
  }, [currentPage]);

  React.useEffect(() => {
    filterops();
  }, [globalIndex, elementePage]);

  React.useEffect(() => {}, [pagesToShow]);
  return (
    <Row>
      <Col className="d-flex justify-content-center">
        <Pagination className="my-1">
          <Pagination.First
            className="hide-md"
            onClick={() => {
              setCurrentPage(1);
            }}
            onKeyDown={() => {
              setCurrentPage(1);
            }}
          />
          <Pagination.Prev
            onClick={() => {
              if (currentPage > 1) setCurrentPage(currentPage - 1);
            }}
            onKeyDown={() => {
              if (currentPage > 1) setCurrentPage(currentPage - 1);
            }}
          />
          {map(pagesToShow, pageNumber => (
            <Pagination.Item
              key={`pagination_${pageNumber}`}
              className="hide-md"
              active={pageNumber === currentPage}
              onClick={() => {
                setCurrentPage(pageNumber);
              }}
              onKeyDown={() => {
                setCurrentPage(pageNumber);
              }}
            >
              {pageNumber}
            </Pagination.Item>
          ))}
          <Pagination.Next
            onClick={() => {
              if (currentPage < totalPage) setCurrentPage(currentPage + 1);
            }}
            onKeyDown={() => {
              if (currentPage < totalPage) setCurrentPage(currentPage + 1);
            }}
          />
          <Pagination.Last
            className="hide-md"
            onClick={() => {
              setCurrentPage(totalPage);
            }}
            onKeyDown={() => {
              setCurrentPage(totalPage);
            }}
          />
        </Pagination>
      </Col>
    </Row>
  );
};
PaginationInterval.defaultProps = {
  currentPage: 1,
  setCurrentPage: () => {},
  globalIndex: 1,
  elementePage: 15,
  elementPagination: 11
};
PaginationInterval.propTypes = {
  currentPage: PropTypes.number,
  setCurrentPage: PropTypes.func,
  globalIndex: PropTypes.number,
  elementePage: PropTypes.number,
  elementPagination: PropTypes.number
};
export default PaginationInterval;
